export default (obj) => (window.dataLayer || []).push(obj)
